import { useEffect, useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, Box } from '@material-ui/core';
import HexagonIcon from '@mui/icons-material/Hexagon';


const SangerPrimerRowColor = memo((props) => {
    const data = props.data;
    const primerColors = props.primerColors;
    const primerKey = props.primerKey;
  
  return (
    <Grid item>
        <Box
        sx={{
            width: 40,
            height: 40,
            backgroundColor: primerColors.get(primerKey),
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex'
        }}
        >
        {data.labPrimer ? <HexagonIcon/> : <></>}
        </Box>
    </Grid>
    );
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id;
});

export default SangerPrimerRowColor;